<template>
    <div>
        <NavBar></NavBar>
        <ImageDimension @sendProfileTubeImgInfo="getProfileImgInfo" @sendLengthValue="getProfileLength"></ImageDimension>
        <RawMatSpeProfile :getImgInfo="profileImgInfo" @sendKiloPrice="getProfileKiloPrice"
            @sendMainProfileTypeIdAndWeigthMeter="getMainProfileTypeIdAndWeigthMeter"></RawMatSpeProfile>
        <ServicesProfile :getProfileImageInfo="profileImgInfo" :getWeigthMeter="profileWeigthMeter"
            :getMainProfileType="profileTypeMainId" @sendTotalServices="getProfileTotalServices"></ServicesProfile>
        <ProfilePrice :getKiloPrice="kiloPrice" :getWeigthMeter="profileWeigthMeter" :getLengthValue="profileLength"
            :getTotalSevices="profileTotalServices">
        </ProfilePrice>
    </div>
</template>
<script>
import NavBar from "@/components/GeneralComponents/NavBarComponent.vue";
import ImageDimension from "@/components/GeneralComponents/ImgDimensionTubPerfComponent.vue"
import RawMatSpeProfile from "@/components/ProfileQuote/ProfileRawMatSpecificactionComponent.vue"
import ServicesProfile from "@/components/ProfileQuote/ProfileServicesQuoteComponent.vue"
import ProfilePrice from "@/components/GeneralComponents/ProfileAndTubePriceComponent.vue"
export default {
    data() {
        return {
            profileLength: 0,
            profileImgInfo: [],
            profileTypeMainId: 0,
            kiloPrice: 0,
            profileWeigthMeter: 0,
            profileTotalServices: 0,
        }
    },
    components: {
        NavBar,
        ImageDimension,
        RawMatSpeProfile,
        ServicesProfile,
        ProfilePrice,
    },
    methods: {
        getProfileLength(data) {
            this.profileLength = data;
            // console.log("Longitud final:" + this.profileLength);
        },
        getProfileImgInfo(data) {
            this.profileImgInfo = data;
            // console.log(this.getProfileImgInfo);
        },
        getProfileKiloPrice(data) {
            this.kiloPrice = data;
            //console.log(this.profileKiloPrice);
        },
        getMainProfileTypeIdAndWeigthMeter(data) {
            // console.log(data);
            this.profileTypeMainId = data.profileTypeId;
            this.profileWeigthMeter = data.weightMeter;
            // console.log("Id" + this.profileTypeMainId);
            // console.log("Peso" + this.profileWeigthMeter);
        },
        getProfileTotalServices(data) {
            this.profileTotalServices = data;
            // console.log(this.profileTotalServices);
        },
    }
}
</script>
<style></style>